<template>
  <div class="wrapper">
    <el-input v-model="search" @input="change">
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </el-input>
    <i v-show="haveText" class="seal-del el-icon-circle-close" @click="delSearch" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      active: false
    }
  },
  computed: {
    noText() {
      if (this.search === '') return true
      return false
    },
    haveText() {
      if (this.search === '') return false
      return true
    }
  },
  methods: {
    change() {
      this.$EventBus.$emit('brotherSearchEvent',this.search)
    },
    delSearch() {
      this.search = ''
      this.change()
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  padding: 15px 15px 5px;
  .seal-del {
    position: absolute;
    right: 20px;
    top: 24px;
    font-size: 22px;
    cursor: pointer;
  }
}
::v-deep .el-input__inner {
  border-color: #1596cd;
  border-radius: 30px;
}
.el-icon-search {
  color: #1596cd;
  font-size: 18px;
}
</style>